<template>
  <div class="wrap">
    <header
      id="header"
      class="header"
      style="
        display: flex;
        align-items: right;
        justify-content: right;
        background-color: rgb(250, 250, 250);
      "
    >
      <div
        style="
          margin-right: 1%;
          display: flex;
          align-items: right;
          justify-content: right;
        "
      >
        <a href="mailto:kumahl@email.com"
          ><img class="headerIcon" src="./img/icon/email1.png"
        /></a>
        <span style="margin-top: 30px">v1.5</span>
      </div>
    </header>
    <div class="row col-md-10 offset-md-1 setCenter" style="margin-top: 80px">
      <router-view v-slot="{ Component }" :key="$route.fullPath">
        <div>
          <component :is="Component" :key="$route.fullPath" />
        </div>
      </router-view>
    </div>
  </div>
</template>

<script>
var myID = "App";

export default {
  name: myID,

  data() {
    return {};
  },

  setup() {},
  methods: {},
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100% !important;
}
#app {
  height: 100% !important;
}
body {
  font-family: "Noto Sans TC", sans-serif !important;
}

.wrap {
  margin: 0;
  background-color: #fff;
  height: 100%;
}
.header {
  background-color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  height: 60px;
  z-index: 3;
}

.setCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.headerIcon {
  width: 50px;
}
</style>
